<template>
	<SimpleModalComponent
		heading="Delete option"
		@close-modal="emit( 'close-modal' )"
	>
		<template #content>
			<p>
				Are you sure you want to delete this option? This action is <strong>irreversible</strong>.
			</p>

			<p
				v-if="error_message"
				class="error-message"
			>
				{{ error_message }}
			</p>
		</template>

		<template #buttons>
			<button
				class="button"
				@click="emit( 'close-modal' )"
			>
				Cancel
			</button>
			<button
				class="button button--fill-danger"
				:class="{ 'button--loading': loading }"
				@click="deleteTheOption"
			>
				Delete
			</button>
		</template>
	</SimpleModalComponent>
</template>

<script setup>
import SimpleModalComponent from './SimpleModalComponent.vue';

import { ref, onMounted, defineEmits, defineProps } from 'vue';
import { useDataStore } from '../../stores/data';

const emit = defineEmits( ['option-deleted', 'close-modal'] );

const props = defineProps( {
	option: {
		required: true,
		type: Object
	}
} );

const { deleteOption, isUserStaffSuperAdmin } = useDataStore();

const loading = ref( false );
const error_message = ref( null );
const user_is_staff_super_admin = ref( false );

const deleteTheOption = async() => { // eslint-disable-line snakecasejs/snakecasejs
	if ( user_is_staff_super_admin.value ) {
		error_message.value = 'You do not have permission to delete options.';
	}

	error_message.value = null;
	loading.value = true;

	try {
		const response = await deleteOption( { option_id: parseInt( props.option.id ) } );
		if ( response && response.data ) {
			if ( response.data.errors ) {
				error_message.value = 'Something went wrong.';
				loading.value = false;
				return;
			}
			emit( 'option-deleted' );
			loading.value = false;
		}
	} catch ( error ) {
		error_message.value = error;
	}
	loading.value = false;
};

onMounted( async() => {
	user_is_staff_super_admin.value = await isUserStaffSuperAdmin();
} );
</script>